import { NgModule } from '@angular/core';
import { QuestionModule } from '../abstract/question.module';
import { OptionAfterschoolModule } from '../../options';
import { QuestionAfterschoolComponent } from './question-afterschool.component';

@NgModule({
  imports: [QuestionModule, OptionAfterschoolModule],
  declarations: [QuestionAfterschoolComponent],
  exports: [QuestionAfterschoolComponent]
})
export class QuestionAfterschoolModule {}
